import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { zipInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

/* eslint-disable no-console */

/**
 * @return {Object} object
 */
function debugging$1() {
  return spaParams.siteParams.debugging && getParameterByName$1('debugging') == 'true'; // eslint-disable-line
}

/**
 * @param {*} name string
 * @param {*} url url
 * @return {Object} decodeURIComponent
 */
function getParameterByName$1(name, url) {
  if (!url) url = window.location.href; // eslint-disable-line
  name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"); // eslint-disable-line
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * @param {*} url url
 * @param {*} methodType type
 * @param {*} payload object
 * @return {void}
 */
function async(url, methodType, payload) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      async: true,
      cache: true,
      dataType: 'JSON',
      type: methodType,
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
      error: jqXHR => {
        reject(jqXHR);
      },
      /**
       * @method success
       * @param payload
       * @desc If response is success
       */
      // eslint-disable-next-line no-shadow
      success: payload => {
        resolve(payload);
      }
    });
  });
}
var Ep = {
  /**
   * @method rates
   * @param {String} url url
   * @param {Object} requestPayload object
   * @param {Object} debugData data to use to debug
   * @description Mortgage & Refinance rate calls
   * @return {void}
   */
  rates(url, requestPayload, debugData) {
    console.time('RATES_REQUEST');
    if (debugging$1()) {
      const response = {
        debugging: true,
        mock: getParameterByName$1('mock'),
        rateInputs: requestPayload.rateInputs,
        ...debugData
      };
      console.log('rates debugging success', response);
      return Promise.resolve(response);
    }
    return async(url, 'POST', requestPayload).then(response => {
      console.timeEnd('RATES_REQUEST');
      // resolve rates
      return Promise.resolve(response);
    }).catch(error => {
      console.timeEnd('RATES_REQUEST');

      // reject error
      return Promise.reject({
        ...error,
        ...requestPayload
      }); // eslint-disable-line
    });
  },
  /**
   * @param {String} url string
   * @param {Object} requestPayload payload
   * @returns {void}
   */
  zipcode(url, requestPayload) {
    return async(url, 'POST', requestPayload).then(response => Promise.resolve(response)).catch(error => Promise.reject(error));
  },
  /**
   * @method leadsCall
   * @param {String} url url
   * @param {Object} requestPayload payload
   * @returns {void}
   */
  leadsCall(url, requestPayload) {
    return async(url, 'POST', requestPayload).then(response => Promise.resolve({
      responsePayload: response,
      requestPayload
    })).catch(error => Promise.reject({
      error,
      requestPayload
    })); // eslint-disable-line
  },
  /**
   * @method leadsPhoneNumberEndpoint
   * @param {String} url
   * @param {String} subCampaignCode
   * @async GET request
   * @desc Will update get leads phone number to display on page
   */
  // ReST API does not currently respece scsCampCode parameter
  leadsPhoneNumberEndpoint(url, subCampaignCode, scsCampCode, debugData) {
    console.time('LEADS_PHONE_NUMBER_REQUEST');
    if (debugging$1()) {
      console.log('leads phone number debugging success', debugData);
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }

    // make leads phone number request
    return async(`${url}${scsCampCode || subCampaignCode}`, 'GET')

    // if leads phone number is successful
    .then(response => {
      console.timeEnd('LEADS_PHONE_NUMBER_REQUEST');
      return Promise.resolve(response);
    })

    // if leads phone number is failure
    .catch(error => {
      console.timeEnd('LEADS_PHONE_NUMBER_REQUEST');
      return Promise.reject(error);
    });
  },
  /**
   * @param {String} url - the url for the AJAX call
   * @param {String} urlParams - affiliate code or nmlsid to be passed in the url
   * @param {Object} debugData - mock data to use for debugging
   * @return {void}
   * @desc Retrieves an affiliate's sub-campaign number and phone number
   */
  getAffiliateInfo(url, urlParams, debugData) {
    if (debugging$1()) {
      return Promise.resolve({
        debugging: true,
        ...debugData
      });
    }
    return async(`${url}${urlParams}`, 'GET').then(response => Promise.resolve(response)).catch(error => Promise.reject({
      error
    })); // eslint-disable-line
  },
  /**
   * @method getPaymentAndRatesHeloc
   * @param {String} url string
   * @param {Object} requestPayload payload
   * @param {Object} debugData data
   * @returns {void}
   */
  getPaymentAndRatesHeloc(url, requestPayload, debugData) {
    if (debugging$1()) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            responsePayload: debugData
          });
        }, 500);
      });
    }
    return async(url, 'POST', requestPayload).then(response => Promise.resolve({
      responsePayload: response,
      requestPayload
    })).catch(error => Promise.reject({
      error,
      requestPayload
    })); // eslint-disable-line
  }
};

/**
 * @method keyMirror
 * @param {Object} obj object
 * @return {Object} ret
 */
function keyMirror(obj) {
  let key;
  const ret = {};
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }

  // eslint-disable-next-line
  for (key in obj) {
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      ret[key] = key;
    }
  }
  return ret;
}
var Cx = keyMirror({
  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT: null,
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT: null,
  HOME_LOANS_AFFORDABILITY_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_AFFORDABILITY_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT: null,
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS: null,
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE: null,
  HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS: null,
  HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT: null,
  HOME_LOANS_ZIP_CODE_CHANGE_SUBMIT: null,
  HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS: null,
  HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE: null,
  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUBMITTED: null,
  HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT: null,
  HOME_LOANS_GENERIC_SUCCESS: null,
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUBMIT: null,
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS: null,
  HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE: null,
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUBMIT: null,
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS: null,
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE: null,
  HOME_LOANS_HOME_EQUITY_CALCULATOR_SUBMIT: null,
  HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_SUCCESS: null,
  HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_FAILURE: null
});

/**
 * @param {*} action object
 * @param {*} payload object
 * @returns {void}
 */
function dispatch(action, payload) {
  // This is a javascript dirty trick. The function passed to
  // setTimeout executes in a new execution context, and exceptions
  // thrown in that context do not bubble out to the calling context
  setTimeout(() => this.Events.pub(action, payload), 0);
}

/**
 * @method eprofileSuccess
 */
var Dp = {
  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      ...payload,
      route: 'mortgage',
      id: '#ratesTableFallbackModule'
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE, {
      ...payload,
      route: 'mortgage',
      id: '#ratesTableFallbackModule'
    });
  },
  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_SUBMI
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT, payload);
  },
  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE, payload);
  },
  /**
   * @method HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_FAILURE, payload);
  },
  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_SUBMI
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT, payload);
  },
  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE, payload);
  },
  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      ...payload,
      route: 'refinance',
      id: '#ratesTableFallbackModule'
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE, {
      ...payload,
      route: 'refinance',
      id: '#ratesTableFallbackModule'
    });
  },
  /**
   * @method HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT, payload);
  },
  /**
   * @method HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @method HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE, payload);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT, payload);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_AFFORDABILITY_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_AFFORDABILITY_RATES_REQUEST_SUCCESS, payload);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_AFFORDABILITY_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_AFFORDABILITY_RATES_REQUEST_FAILURE, payload);
  },
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS, payload);
  },
  HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE, payload);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT() {
    dispatch.bind(this)(Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT, {});
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS, payload);
  },
  /**
   * @param {Object} error object
   * @returns {void}
   */
  HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE(error) {
    dispatch.bind(this)(Cx.HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE, error);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT() {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, {});
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS, payload);
  },
  /**
   * @param {Object} payload object
   * @returns {void}
   */
  HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_OVERVIEW_NEW_ZIP_CODE_SUBMIT, payload);
  },
  /**
   * @method HOME_LOANS_GET_A_CALL_BACK_REQUEST_FAILURE
   */
  // eslint-disable-next-line
  HOME_LOANS_LEADS_CALL_REQUEST_FAILURE(error) {
    if (error.error.responseJSON && error.error.responseJSON.fieldErrors) {
      dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_VALIDATION_ERRORS, error.error.responseJSON.fieldErrors); // eslint-disable-line
      return true;
    }
    dispatch.bind(this)(Cx.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE, error);
  },
  HOME_LOANS_GENERIC_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_GENERIC_SUCCESS, payload);
  },
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS(payload) {
    const route = {
      ...payload,
      route: false,
      id: '#ratesTableFallbackModule'
    };
    payload = {
      ...route
    }; // eslint-disable-line
    dispatch.bind(this)(Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS, payload);
  },
  HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE, {
      ...payload,
      route: false,
      id: '#ratesTableFallbackModule'
    });
  },
  HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS, payload);
  },
  HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE(error) {
    dispatch.bind(this)(Cx.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE, error);
  },
  HOME_LOANS_HOME_EQUITY_CALCULATOR_SUBMIT(payload) {
    dispatch.bind(this)(Cx.HOME_LOANS_HOME_EQUITY_CALCULATOR_SUBMIT, payload);
  }
};

/* eslint-disable no-console */
const mockResultHelocCalc = {
  belowThreshold: {
    heloanComparisonDetail: null,
    helocMyRequestComparisonDetail: {
      lineAmount: 100000.0,
      monthlyPayment: 0,
      apr: 5.3,
      drawPeriod: 120.0,
      homeEquityComparisonType: 'MyRequest'
    },
    helocBestFitComparisonDetail: null,
    helocMaxAmountComparisonDetail: {
      lineAmount: 325000.0,
      monthlyPayment: 0,
      apr: 5.8,
      drawPeriod: 120.0,
      homeEquityComparisonType: 'MaxAmount'
    },
    frloComparisonDetail: null,
    timeStamp: 1547753200513,
    branchCode: null,
    branchSatelliteCode: null,
    isMLO: null,
    creditRating: 'Excellent',
    currentYear: '01/17/2019 02:26 PM ET',
    maximumAmount: 325000.0,
    errorCode: null
  },
  aboveThreshold: {
    heloanComparisonDetail: null,
    helocMyRequestComparisonDetail: {
      lineAmount: 100000.0,
      monthlyPayment: 215.0,
      apr: 5.0,
      drawPeriod: 120.0,
      homeEquityComparisonType: 'MyRequest'
    },
    helocBestFitComparisonDetail: null,
    helocMaxAmountComparisonDetail: {
      lineAmount: 325000.0,
      monthlyPayment: 227.0,
      apr: 5.5,
      drawPeriod: 120.0,
      homeEquityComparisonType: 'MaxAmount'
    },
    frloComparisonDetail: {
      lineAmount: 40000.0,
      monthlyPayment: 255.0,
      apr: 6.579,
      drawPeriod: 0.0,
      homeEquityComparisonType: 'MyRequest'
    },
    timeStamp: 1547752728623,
    branchCode: null,
    branchSatelliteCode: null,
    isMLO: null,
    creditRating: 'Excellent',
    currentYear: '01/17/2019 02:18 PM ET',
    maximumAmount: 325000.0,
    errorCode: null
  }
};
const mockVariablePayload = {
  pDSProcessID: null,
  pDSErrCode: null,
  pDSErrDesc: null,
  product: {
    productName: 'HELOC',
    productCode: null,
    productSubCode: null,
    productSubClass: null,
    productIdentifier: null,
    productType: null,
    effectiveDate: null,
    resultType: 'MyRequest',
    amorizationTerm: '360.0',
    currentAPR: 5.9,
    currentRate: 5.9,
    lineLoanAmount: 100000.0,
    fixedPayment: 356.0,
    termDraw: 120.0,
    totalAmountFinanced: 100000.0,
    regionState: null,
    promoOffer: {
      introRateType: 'V',
      introRateAmount: 3.99,
      introOfferEndDate: null,
      campaignDescriptor: 'Variable APR for 12 months',
      promoDisclosure: 'You are invited to apply for a Home Equity Line of Credit (HELOC). Your receipt of this material does not mean you have been pre-qualified or pre-approved for any product or service we offer. This is not a commitment to lend; you must submit additional information for review and approval. Sample Rate(s) and APR(s) are for illustrative purposes only and are subject to change without notice. Offer available for new applications submitted between 7/1/19 and 03/31/20 for qualified borrowers with approved line sizes of $100,000 or greater and the 12 month Introductory Period begins on the date the HELOC account is opened.'
    },
    discountRate: '0.85',
    defaultDiscountRate: '0.25',
    udeDiscountRate: '0.60'
  },
  monthlyPaymentAmount: null,
  wsjIndex: 5.5,
  wsjIndexForPopup: null,
  state: 'CA'
};
const mockBauPayload = {
  pDSProcessID: null,
  pDSErrCode: null,
  pDSErrDesc: null,
  product: {
    productName: 'HELOC',
    productCode: null,
    productSubCode: null,
    productSubClass: null,
    productIdentifier: null,
    productType: null,
    effectiveDate: null,
    resultType: 'MyRequest',
    amorizationTerm: '360.0',
    currentAPR: 5.9,
    currentRate: 5.9,
    lineLoanAmount: 100000.0,
    fixedPayment: 356.0,
    termDraw: 120.0,
    totalAmountFinanced: 100000.0,
    regionState: null,
    promoOffer: null,
    discountRate: '0.85',
    defaultDiscountRate: '0.25',
    udeDiscountRate: '0.60'
  },
  monthlyPaymentAmount: null,
  wsjIndex: 5.5,
  wsjIndexForPopup: null,
  state: 'CA'
};

/**
 * @method hasRates
 * @param {Object} payload - the response to a rates AJAX call
 * @returns {Object} true if any product provides a valid rate
 */
const hasRates = payload => {
  const some = _.some(payload.mortgageProducts, product => product.rateDetails && product.rateDetails.rate);
  return payload.mortgageProducts && some;
};
const hasAffordabilityRates = payload => payload.status !== 'ERROR' && payload.result !== null && payload.errors === null;

/**
 * @param {String} name name
 * @return {Object} result
 */
function getParameterByName(name) {
  const url = window.location.href;
  name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * @return {*} parameter
 */
function debugging() {
  return getParameterByName('debugging') === 'true' || getParameterByName('mock') === 'local';
}
var Tf = {
  mortgageRates(calcInput) {
    // get mortgage rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.mortgage;
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp[spaParams.pageParams.payload];
    let payload = payloadTemp.payloads;
    const debugData = payloadTemp.debugData || {};

    // if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
    }
    payload = payload.mortgage;

    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payload, debugData);
    return mortgageRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasRates(payload)) {
        const {
          rateInputs
        } = payload;
        const rates = {
          ...payload,
          rateInputs: {
            ...rateInputs,
            downpaymentPercentage: 100.00 - rateInputs.loantoValueRatio
          },
          mortgageProducts: payload.mortgageProducts.map(product => {
            const {
              rateDetails
            } = product;
            const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
            if (pmi) {
              const {
                armAssumptions
              } = rateDetails;
              if (armAssumptions) {
                const paymentTypes = ['armInitialPaymentAmount', 'armFullyIndexedRatePaymentAmount', 'armSubsequentPaymentAdjustAmount_1', 'armSubsequentPaymentAdjustAmount_2', 'armSubsequentPaymentAdjustAmount_3', 'armMaximumInitialRatePayment', 'armMaximumSubsequentResetPayment', 'armMaximumLifetimePayment'];
                paymentTypes.forEach(type => {
                  const paymentAmount = armAssumptions && armAssumptions[type];
                  if (paymentAmount) {
                    armAssumptions[type] += pmi;
                  }
                });
              }
              if (rateDetails.monthlyPayment) {
                rateDetails.monthlyPayment += pmi;
              }
            }
            return product;
          })
        };
        return Promise.resolve(rates);
      }
      // eslint-disable-next-line
      return Promise.reject({
        error: 'no rates were returned',
        rateInputs: payload.rateInputs
      });
    }).catch(error => {
      // eslint-disable-next-line
      const rej = Promise.reject({
        ...error,
        rateInputs: payload.rateInputs
      });
      return rej;
    });
  },
  refinanceRates(calcInput) {
    // get refinance rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.refinance;
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp[spaParams.pageParams.payload];
    let payload = payloadTemp.payloads;
    const debugData = payloadTemp.debugData || {};

    // if calcInput then replace spa params
    if (calcInput) {
      payload.refinance.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.refinance.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.refinance.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      // calculate effective down payment
      // eslint-disable-next-line max-len
      payload.refinance.rateInputs.downPayment = calcInput.rateInputs.purchasePrice - calcInput.rateInputs.amountBorrowed;
    }
    payload = payload.refinance;

    // Let's create the promise for refinance rates request
    const refinanceRatesRequest = Ep.rates(url, payload, debugData);
    return refinanceRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasRates(payload)) {
        const rates = {
          ...payload,
          mortgageProducts: payload.mortgageProducts.map(product => {
            const {
              rateDetails
            } = product;
            const pmi = rateDetails && rateDetails.mortgageInsuranceAmount;
            if (pmi && rateDetails.monthlyPayment) {
              rateDetails.monthlyPayment += pmi;
            }
            return product;
          })
        };
        return Promise.resolve(rates);
      }
      // eslint-disable-next-line
      return Promise.reject({
        error: 'no rates were returned',
        rateInputs: payload.rateInputs
      });
    }).catch(error => {
      // eslint-disable-next-line
      const rej = Promise.reject({
        ...error,
        rateInputs: payload.rateInputs
      });
      return rej;
    });
  },
  homeEquityRates() {
    // collect page params for home equity
    const payloads = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    const inputs = payloads.homeEquityOverview;
    inputs.state = this.Store.getUserSelectedState();
    if (!inputs.state) {
      inputs.state = spaParams.pageParams.defaultState;
      this.Store.addData('state', inputs.state || '');
    }

    // create homeEquity rates request
    const homeEquityRatesRequest = Ep.rates(spaParams.siteParams.endpoints.homeEquity.url, inputs);

    // run homeEquity rates request
    return homeEquityRatesRequest.then(payload => {
      const {
        mock
      } = payload;
      if (!spaParams.siteParams.isProd && mock === 'promo') {
        return Promise.resolve(mockVariablePayload);
      }
      if (!spaParams.siteParams.isProd && mock === 'bau') {
        return Promise.resolve(mockBauPayload);
      }
      this.Store.addData('home_equity_rates', payload);
      return Promise.resolve(payload);
    }).catch(error => {
      // eslint-disable-next-line
      const rej = Promise.reject({
        ...error,
        rateInputs: payload.rateInputs // eslint-disable-line
      });
      return rej;
    });
  },
  assumptionsRates() {
    const params = Utility.getQueryParamValues(window.location.href);
    const loanType = params && params.loanType || spaParams.pageParams.loanType;
    const rates = this.Store.getData(`${loanType}AssumptionsRates`);
    if (rates) {
      return Promise.resolve(rates);
    }

    // collect page params for home equity
    const payloads = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    const defaultInputs = payloads.assumptions.payloads[loanType];
    const {
      rateInputs
    } = defaultInputs;
    let inputs;
    if (loanType === 'homeEquity') {
      // state can either be in query parm,
      // if not there then grab from cookie, if not there then make CA
      const state = params && params.state || spartaGlobalFunctions.spartaGetCookie('state') || 'CA';
      inputs = {
        ...defaultInputs,
        state
      };
    } else {
      const postalCode = params && params.zipcode || rateInputs.postalCode; // eslint-disable-line
      const purchasePrice = new Number(params && params.purchasePrice || rateInputs.purchasePrice); // eslint-disable-line
      const downPayment = new Number(params && params.downPayment || rateInputs.downPayment); // eslint-disable-line
      const downpaymentPercentage = rateInputs.downpaymentPercentage || downPayment / purchasePrice * 100.; // eslint-disable-line
      const amountBorrowed = purchasePrice - downPayment;
      const overrides = {
        ...defaultInputs.rateInputs,
        postalCode,
        purchasePrice,
        downPayment,
        downpaymentPercentage,
        amountBorrowed
      };
      inputs = {
        ...defaultInputs,
        rateInputs: overrides
      };
    }
    const {
      url
    } = spaParams.siteParams.endpoints[loanType];

    // create rates request
    const debugData = payloads.assumptions.debugData[loanType];
    const ratesRequest = Ep.rates(url, inputs, debugData);

    // run rates request
    return ratesRequest.then(response => {
      if (/^(mortgage|refinance)$/.test(loanType)) {
        const {
          rateInputs
        } = response; // eslint-disable-line
        const rates = Object.assign({}, response, {
          // eslint-disable-line
          rateInputs: {
            ...rateInputs,
            downpaymentPercentage: 100.00 - rateInputs.loantoValueRatio
          },
          mortgageProducts: _.fromPairs(response.mortgageProducts.map(product => {
            const key = product.productCode;
            return [key, product];
          }))
        });
        this.Store.addData(`${loanType}AssumptionsRates`, rates);
        return Promise.resolve(rates);
      }
      return Promise.resolve({
        ...response,
        loanType
      });
    }).catch(error => Promise.reject(error));
  },
  closingCostCalculatorRates(calcInput) {
    // get mortgage rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.closingCosts;
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp[spaParams.pageParams.payload];
    let payload = payloadTemp.payloads;
    // just take the first element from the debug array
    // since we really just want some fake dollar amounts
    const debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }
    const {
      debtToIncomeInputs
    } = calcInput.rateInputs;
    // if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      payload.mortgage.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage; // eslint-disable-line max-len

      // based on product we need delete other elements
      var productWeNeed = $.grep(payload.mortgage.mortgageProducts, v => {
        // eslint-disable-line
        return v.productName == calcInput.rateInputs.mappingProduct; // eslint-disable-line
      });
    }
    payload = payload.mortgage;

    // construct fresh object so we don't update mortgage products reference and reduce it to a 1 element array
    const payloadFinal = {
      rateInputs: payload.rateInputs,
      mortgageProducts: productWeNeed,
      debtToIncomeInputs
    }; // eslint-disable-line

    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payloadFinal, debugData);
    return mortgageRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasRates(payload)) {
        return Promise.resolve(payload);
      }
      return Promise.reject({
        error: 'no rates were returned'
      }); // eslint-disable-line
    }).catch(error => Promise.reject(error));
  },
  affordabilityCalculatorRates(calcInput) {
    // get affordabilityCost rates endpoint url
    let url;
    if (debugging()) {
      ({
        mockurl: url
      } = spaParams.siteParams.endpoints.affordabilityCost);
    } else {
      ({
        url
      } = spaParams.siteParams.endpoints.affordabilityCost);
    }
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp.affordabilityCost;
    const payload = payloadTemp.payloads;
    const debugData = payloadTemp.debugData || {};
    if (calcInput) {
      ({
        postalCode: payload.rateInputs.postalCode
      } = calcInput.rateInputs);
      ({
        debtToIncomeInputs: payload.debtToIncomeInputs,
        firstPassResultInputs: payload.firstPassResultInputs
      } = calcInput);
      if (calcInput.downPayment) {
        payload.rateInputs.downPayment = calcInput.downPayment;
      }
    }

    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payload, debugData);
    return mortgageRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasAffordabilityRates(payload)) {
        return Promise.resolve(payload);
      }
      return Promise.reject({
        error: 'no rates were returned'
      }); // eslint-disable-line
    }).catch(error => Promise.reject(error));
  },
  /**
   * @return {void}
   * @param {Object} calcInput object
   */
  mortgageCalculatorRates(calcInput) {
    // get mortgage rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.mortgage;
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp[spaParams.pageParams.payload];
    let payload = payloadTemp.payloads;
    // just take the first element from the debug array
    //  since we really just want some fake dollar amounts
    const debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }
    const {
      debtToIncomeInputs
    } = calcInput.rateInputs;
    // if calcInput then replace spa params
    if (calcInput) {
      payload.mortgage.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.mortgage.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.mortgage.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.mortgage.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      // eslint-disable-next-line max-len
      payload.mortgage.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage;

      // based on product we need delete other elements
      var productWeNeed = $.grep(payload.mortgage.mortgageProducts, v => {
        // eslint-disable-line
        return v.productCode == calcInput.rateInputs.mappingProduct; // eslint-disable-line
      });
    }
    payload = payload.mortgage;

    // construct fresh object so we don't update mortgage products
    // reference and reduce it to a 1 element array
    let payloadFinal = {
      rateInputs: payload.rateInputs,
      mortgageProducts: productWeNeed,
      debtToIncomeInputs
    }; // eslint-disable-line

    // Let's create the promise for mortgage rates request
    const mortgageRatesRequest = Ep.rates(url, payloadFinal, debugData);
    return mortgageRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasRates(payload)) {
        return Promise.resolve(payload);
      }
      return Promise.reject({
        error: 'no rates were returned'
      }); // eslint-disable-line
    }).catch(error => Promise.reject(error));
  },
  /**
   * @return {void}
   * @param {Object} calcInput object
   */
  homeEquityCalculatorRates(calcInput) {
    return new Promise((resolve, reject) => {
      const params = Utility.getQueryParamValues(window.location.href) || {};
      const endpoint = spaParams.siteParams.endpoints.getPaymentAndRatesHeloc.url;
      const debugData = params.aboveThreshold ? mockResultHelocCalc.aboveThreshold : mockResultHelocCalc.belowThreshold;
      const rates = Ep.getPaymentAndRatesHeloc(endpoint, calcInput, debugData);
      rates.then(payload => {
        resolve({
          ...payload,
          ...{
            responsePayload: {
              ...payload.responsePayload,
              ...{
                formInputs: calcInput
              }
            }
          }
        });
      }, error => {
        reject(console.error(`ERROR: Rates call failed with error - ${error}`));
      });
    });
  },
  /**
   * @return {Object} produce code
   * @param {Object} calcInput object
   */
  refinanceCalculatorRates(calcInput) {
    // get mortgage rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.refinance;
    let payloadTemp = JSON.parse(document.getElementById('ratePayloads').dataset.jcr);
    payloadTemp = payloadTemp[spaParams.pageParams.payload];
    let payload = payloadTemp.payloads;
    // just take the first element from the debug array
    // since we really just want some fake dollar amounts
    const debugData = payloadTemp.debugData || {};
    if (debugData.mortgageProducts) {
      debugData.mortgageProducts.splice(1, debugData.mortgageProducts.length - 1);
    }

    // if calcInput then replace spa params
    if (calcInput) {
      payload.refinance.rateInputs.postalCode = calcInput.rateInputs.postalCode;
      payload.refinance.rateInputs.purchasePrice = calcInput.rateInputs.purchasePrice;
      payload.refinance.rateInputs.amountBorrowed = calcInput.rateInputs.amountBorrowed;
      payload.refinance.rateInputs.downPayment = calcInput.rateInputs.downPayment;
      payload.refinance.rateInputs.downpaymentPercentage = calcInput.rateInputs.downpaymentPercentage; // eslint-disable-line max-len

      // based on product we need delete other elements
      // eslint-disable-next-line vars-on-top, no-var
      var productWeNeed = $.grep(payload.refinance.mortgageProducts, function (v) {
        // eslint-disable-line
        return v.productCode == calcInput.rateInputs.mappingProduct; // eslint-disable-line
      });
    }
    payload = payload.refinance;

    // construct fresh object so we don't update mortgage products
    //  reference and reduce it to a 1 element array
    let payloadFinal = {
      rateInputs: payload.rateInputs,
      mortgageProducts: productWeNeed
    }; // eslint-disable-line

    const refinanceRatesRequest = Ep.rates(url, payloadFinal, debugData);
    return refinanceRatesRequest.then(payload => {
      // eslint-disable-line
      if (hasRates(payload)) {
        return Promise.resolve(payload);
      }
      return Promise.reject({
        error: 'no rates were returned'
      }); // eslint-disable-line
    }).catch(error => Promise.reject(error));
  },
  /**
   * @returns {Object} call
   * @param {Object} payload object
   */
  leadsCall(payload) {
    const inputs = {};

    // format email, zip, phone
    inputs.custEmail = payload.emailAddress.trim();
    inputs.mailZipcode = payload.zipCode.slice(0, 5);
    inputs.phoneDay = payload.phoneNumber.replace(/[^\d]/g, '').slice(0, 10);

    // names
    inputs.custFirstName = payload.firstName;
    inputs.custLastName = payload.lastName;

    // format mortgage loan purpose & sub campaign code
    inputs.mtgLoanPurpose = payload.mtgLoanPurpose || spaParams.pageParams.purpose;
    inputs.subCampaignCode = payload.subCampaignCode || spaParams.pageParams.subCampCode;

    // make leads call
    return Ep.leadsCall(spaParams.siteParams.endpoints.leadsCall.url, inputs)

    // on leads call success
    // eslint-disable-next-line no-shadow
    .then(payload => Promise.resolve(payload))

    // on leads call failure
    .catch(error => Promise.reject(error));
  },
  /**
   * @returns {void}
   */
  leadPhoneNumber() {
    // params
    const params = Utility.getQueryParamValues(window.location.href);
    // get persisted campaign code
    const persistedSubCampCode = this.Store.getPersisted('subCampCode');
    let subCampCode = persistedSubCampCode && persistedSubCampCode.code;
    const keys = Object.keys(params || {});

    // if param exist
    let key = keys.find(key => /subcampcode/i.test(key) ? key : false); // eslint-disable-line
    if (key) {
      subCampCode = params[key];
    }
    key = keys.find(key => /scscampcode/i.test(key) ? key : false); // eslint-disable-line
    const scsCampCode = key && params[key];

    // sub campaign code
    if (!subCampCode) {
      subCampCode = spaParams.pageParams.subCampCode; // eslint-disable-line
    }
    key = keys.find(key => /loanpurpose/i.test(key) ? key : false); // eslint-disable-line
    const loanPurpose = key && params[key] || spaParams.pageParams.purpose;

    // there was some discussion of affiliate code coming from a cookie rather than a query param
    key = Object.keys(params || {}).find(key => /affiliatecode/i.test(key) ? key : false); // eslint-disable-line
    let affiliateCode = key && params[key];
    // fetching nmls from cookie
    key = Object.keys(params || {}).find(key => /nmls/i.test(key) ? key : false); // eslint-disable-line
    let nmls = key && params[key];
    let urlParams = null;
    if (nmls) urlParams = `nmls=${nmls}`;else if (affiliateCode) urlParams = `affiliateCode=${affiliateCode}`;else if (!nmls && !affiliateCode) {
      // try to read the affiliate code from a cookie
      const matches1 = document.cookie.match(/boa_hlts_mlo=([^;]+);/);
      const matches2 = document.cookie.match(/boa_hlts_mlo_affiliate=([^;]+);/);
      if (matches1 && matches1.length > 1) {
        nmls = matches1[1]; // eslint-disable-line
        urlParams = `nmls=${nmls}`;
      } else if (matches2 && matches2.length > 1) {
        affiliateCode = matches2[1]; // eslint-disable-line
        urlParams = `affiliateCode=${affiliateCode}`;
      }
    }
    if (urlParams) {
      return Ep.getAffiliateInfo(spaParams.siteParams.endpoints.getAffiliateInfo.url, urlParams, spaParams.siteParams.endpoints.getAffiliateInfo.debugData).then(response => {
        const phone = response.phoneNumber;
        const matches = phone && phone.match(/(\d{3})(\d{3})(\d{4})/);
        if (matches.length > 3) {
          const digitGroups = matches.slice(1, 4);
          const phoneNumber = digitGroups.join('-');
          this.Store.addData('phoneNumber', {
            phoneNumber
          });
          this.Store.persist('subCampCode', {
            code: response.subCampCode
          });
          // eslint-disable-next-line no-shadow
          const {
            debugging,
            firstName: fName,
            lastName: lName
          } = response;
          const Source = 'MLOWebsite';
          const Subsource = 'Prequal';
          const originationCode = '18098';
          return Promise.resolve({
            debugging,
            scsCampCode,
            subCampCode,
            phoneNumber,
            affiliateCode: affiliateCode,
            nmls: nmls,
            fName,
            lName,
            loanPurpose,
            Source,
            Subsource,
            originationCode,
            raw: response
          });
        }
        return Promise.reject({
          error: 'no valid phone number provided'
        }); // eslint-disable-line
      }).catch(error => Promise.reject({
        error
      })); // eslint-disable-line
    }
    const {
      debugData
    } = spaParams.siteParams.endpoints.leadsPhoneNumber;
    // lets make phone number call
    return Ep.leadsPhoneNumberEndpoint(spaParams.siteParams.endpoints.leadsPhoneNumber.url, subCampCode, scsCampCode, debugData).then(payload => {
      // add to store
      this.Store.addData('phoneNumber', payload);
      // persist data
      this.Store.persist('subCampCode', {
        code: subCampCode
      });

      // return promise
      return Promise.resolve({
        scsCampCode,
        subCampCode,
        ...payload
      });
    }).catch(error => Promise.reject({
      error,
      scsCampCode,
      subCampCode
    })); // eslint-disable-line
  }
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div type=\"text/json\" id=\"ratePayloads\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ratePayloads") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":50},"end":{"line":1,"column":71}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/services-home-loans-module",
  "version": "3.0.3",
  "id": "servicesHomeLoansModule",
  "containerID": "homeLoansServicesHomeLoansModule",
  "moduleName": "home-loans-services-home-loans-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "services-home-loans-module",
  "data": {
    "init": "servicesHomeLoansModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "controller",
    "type": "string",
    "default": "",
    "description": "This parameter allows changing the controller"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        zipInput,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    zipInput,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-global-functions-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* eslint-disable max-len */

/**
 * @export
 * @class servicesHomeLoansModule
 * @extends {Module}
 */
class servicesHomeLoansModule extends Module {
  /**
   * Creates an instance of AffordabilityBudgetModule.
   * @param {Object} options Module option
   * @param {Object} context Module context
   */
  constructor(options, context) {
    // Extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  mortgageOverview(calcInput) {
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  refinanceOverview(calcInput) {
    Tf.refinanceRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  adjustableRateMortgageProduct(calcInput) {
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  fixedRateMortgageRatesProduct(calcInput) {
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} zipInput object
   * @return {void}
   */
  fixedRateRefinanceProduct(zipInput) {
    Tf.refinanceRates.bind(this)(zipInput).then(payload => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  adjustableRateRefinanceProduct(calcInput) {
    Tf.refinanceRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  jumboLoanMortgageProduct(calcInput) {
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} calcInput object
   * @return {void}
   */
  mortgageRates(calcInput) {
    Tf.mortgageRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} zipInput object
   * @return {void}
   */
  refinanceRates(zipInput) {
    Tf.refinanceRates.bind(this)(zipInput).then(payload => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @return {void}
   */
  homeEquityRates() {
    Tf.homeEquityRates.bind(this)().then(response => Dp.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS.bind(this)(response)).catch(error => Dp.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE.bind(this)(error));
  }

  /**
   * @return {void}
   */
  assumptions() {
    Tf.assumptionsRates.bind(this)().then(response => Dp.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS.bind(this)(response)).catch(error => Dp.HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE.bind(this)(error));
  }

  /**
   * @return {void}
   */
  generic() {
    setTimeout(() => {
      Dp.HOME_LOANS_GENERIC_SUCCESS.bind(this)(null);
    }, 1000);
  }

  /**
   * @return {void}
   * @param {Object} request object
   */
  closingCost(request) {
    const calcInput = request.data;
    Tf.closingCostCalculatorRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @return {void}
   * @param {Object} request object
   */
  affordabilityCalc(request) {
    const calcInput = request.data;
    Tf.affordabilityCalculatorRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_AFFORDABILITY_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_AFFORDABILITY_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  zipcode(request) {
    const payload = request.data;

    // get zipCodeLookup rates endpoint url
    const {
      url
    } = spaParams.siteParams.endpoints.zipcode;

    // Let's create the promise for zipcode rates request
    const zipcodeRequest = Ep.zipcode(url, payload);

    // Making zip code rates request
    zipcodeRequest.then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_ZIP_CODE_LOCATOR_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_ZIP_CODE_LOCATOR_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  leadsCall(request) {
    const payload = request.data;

    // Making leads call
    Tf.leadsCall(payload).then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_LEADS_CALL_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  chooseCalculatorSubmitController(request) {
    const inp = request.data;

    // get controller
    const {
      controller
    } = spaParams.pageParams;

    // call controller passing in inputs from calculator
    this[controller](inp);
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  chooseZipCodeChangeSubmitController(request) {
    const inp = request.data;

    // get controller
    const {
      controller
    } = spaParams.pageParams;

    // call controller passing in inputs from calculator
    this[controller](inp);
  }

  /**
   * @method leadsPhoneNumber
   * @return {void}
   */
  leadsPhoneNumber() {
    Tf.leadPhoneNumber.bind(this)().then(payload => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} payload object
   * @return {void}
   */
  mortgageCalculator(payload) {
    Tf.leadPhoneNumber.bind(this)().then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
    });
    Tf.mortgageRates.bind(this)(payload).then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  mortgageCalculatorResult(request) {
    const calcInput = request.data;
    Tf.mortgageCalculatorRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  homeEquityCalculatorResult(request) {
    const calcInput = request.data;
    Tf.homeEquityCalculatorRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_HOME_EQUITY_CALCULATOR_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} request object
   * @return {void}
   */
  refinanceCalculatorResult(request) {
    const calcInput = request.data;
    Tf.refinanceCalculatorRates.bind(this)(calcInput).then(payload => {
      Dp.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @param {Object} payload object
   * @return {void}
   */
  refinanceCalculator(payload) {
    Tf.leadPhoneNumber.bind(this)().then(payload => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_PHONE_NUMBER_REQUEST_FAILURE.bind(this)(error);
    });
    Tf.refinanceRates.bind(this)(payload).then(payload => {
      // eslint-disable-line
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS.bind(this)(payload);
    }).catch(error => {
      Dp.HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE.bind(this)(error);
    });
  }

  /**
   * @return {void}
   */
  init() {
    this.Store.removePersisted('subCampCode');
    this.Store.removePersisted('subCampaignCode');

    // Leads phone number
    this.leadsPhoneNumber.bind(this)();

    // Get current page
    const {
      controller
    } = spaParams.pageParams;
    // Run current controller
    if (controller) {
      this[controller]();
    }
    // any controller will subscribe to a modules publish
    spartaEventsUtility.sub(Cx.HOME_LOANS_ZIP_CODE_CHANGE_SUBMIT, this.chooseZipCodeChangeSubmitController.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_ZIP_CODE_LOCATOR_SUBMIT, this.zipcode.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_LEADS_CALL_REQUEST_SUBMIT, this.leadsCall.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_RATES_TABLE_CALCULATOR_SUBMIT, this.chooseCalculatorSubmitController.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUBMIT, this.homeEquityRates.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT, this.closingCost.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_AFFORDABILITY_CALCULATOR_SUBMIT, this.affordabilityCalc.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_MORTGAGE_CALCULATOR_SUBMIT, this.mortgageCalculatorResult.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_REFINANCE_CALCULATOR_SUBMIT, this.refinanceCalculatorResult.bind(this));
    spartaEventsUtility.sub(Cx.HOME_LOANS_HOME_EQUITY_CALCULATOR_SUBMIT, this.homeEquityCalculatorResult.bind(this));
  }
}
registerModuleClass({
  moduleClass: servicesHomeLoansModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { servicesHomeLoansModule as default, moduleConfig };
